<template>
  <div>
    <login-header v-bind="headerInfo" :userDisplayFlag="false"></login-header>
    <div class="content">
      <div class="zc-box zh-box">
        <div style="height: 50px"></div>
        <el-form ref="form" :model="form" label-width="150px" class="dl-list">
          <el-form-item>
            <span slot="label">
              <span style="color: #f00">*</span>店铺名称：
            </span>
            <el-input v-model="form.store_name" placeholder="请填写店铺名称"></el-input>
          </el-form-item>
          <el-form-item style="margin: -22px 0 0">
            <span slot="label"></span>
            <span>建议店铺名称设置在10字以内，名称过长会导致小程序端显示不全</span>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <span style="color: #f00">*</span>店铺行业分类：
            </span>
            <el-select v-model="form.industry_id" placeholder="请选择" class="inputWidth" :disabled="disabled">
              <el-option
                v-for="item in industryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <span style="color: #f00">*</span>手机号：
            </span>
            <el-input class="inputWidth" v-model="form.mobile" placeholder="请填写手机号" maxlength="11"></el-input>
            <el-button type="primary" class="btn__send-code" :disabled="isLock || codeInterval !== 60" @click="sendCode">{{codeInterval !== 60 ? codeInterval + 's' : '获取验证码'}}</el-button>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <span style="color: #f00">*</span>验证码：
            </span>
            <el-input class="inputWidth" v-model="form.verify_code" placeholder="请填写验证码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn__create" @click="createStore">立即创建</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'

let codeTimers = null

export default {
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      headerInfo: {
        type: '创建店铺',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      description: '',
      // 店铺行业列表
      industryList: [],
      form: {
        store_name: '',
        mobile: '',
        verify_code: '',
        industry_id: ''
      },
      isLock: false,
      codeInterval: 60,
      instanceId: '',
      disabled: false,
      isIotPage: false
    }
  },
  created() {
    const query = this.$route.query || {}
    this.instanceId = query.instanceId
    // 默认选中行业
    if (query.industry_id) {
      this.form.industry_id = Number(query.industry_id)
      this.disabled = true
    }
    if (!this.instanceId) {
      this.$router.replace({ path: `/index.html` })
      return
    }
    if (query.is_iot_page == 1) {
      this.isIotPage = true
    }

    const mobile = localStorage.getItem('mobile')
    this.headerInfo.userName = mobile

    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    this.description = this.loginInfo.description

    this.getIndustry()
  },
  methods: {
    getIndustry() {
      QM.apinew({
        url: '/seller/industry/list',
        method: 'get',
        data: {
          type_id: 40
        },
        success: xdata => {
          this.industryList = xdata.data.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        }
      })
    },
    sendCode() {
      const mobile = this.form.mobile
      if (!mobile) {
        this.$message.error('请填写手机号')
        return
      }
      if (!/^1\d{10}$/.exec(mobile)) {
        this.$message.error('请填写正确的手机号')
        return
      }
      if (this.isLock) return
      this.isLock = true

      QM.apinew({
        url: '/seller/account/send-verify-code',
        method: 'post',
        data: {
          mobile,
          type: 'login'
        },
        success: res => {
          this.setCodeInterval()
          this.isLock = false
          this.$message({
            message: '发送成功，请注意查收',
            type: 'success'
          })
        },
        error(err) {
          this.isLock = false
        }
      })
    },
    setCodeInterval() {
      const fn = () => {
        this.codeInterval--
        if (this.codeInterval <= 0) {
          this.clearCodeInterval()
        }
      }
      fn()
      codeTimers = setInterval(fn, 1000)
    },
    clearCodeInterval() {
      clearInterval(codeTimers)
      codeTimers = null
      this.codeInterval = 60
    },
    createStore() {
      if (!this.form.store_name) {
        this.$message.error('请填写店铺名称')
        return
      }
      if (!this.form.industry_id) {
        this.$message.error('请选择店铺行业分类')
        return
      }
      if (!this.form.mobile) {
        this.$message.error('请填写手机号')
        return
      }
      if (!/^1\d{10}$/.exec(this.form.mobile)) {
        this.$message.error('请填写正确的手机号')
        return
      }
      if (!this.form.verify_code) {
        this.$message.error('请填写验证码')
        return
      }

      QM.apinew({
        url: '/seller/account/bind-aliyun-instance',
        method: 'post',
        data: {
          instance_id: decodeURIComponent(this.instanceId || ''),
          ...this.form
        },
        success: () => {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          if (this.isIotPage) {
            this.$router.replace({ path: '/qingting/active-process.html' })
            return
          }
          this.$router.replace({ path: '/index.html' })
        },
        error: err => {
          if (err && err.message) this.$message.error(err.message)
        }
      })
    }
  }
}
</script>

<style scoped>
.zc-box {
  width: 580px;
}
.inputWidth {
  width: 200px;
}
.selected {
  width: 100%;
}
.btn__send-code {
  margin-left: 10px;
  min-width: 112px;
}
.btn__create {
  width: 390px;
  margin: 15px 0 35px;
  font-size: 18px;
  height: 50px;
}
</style>